import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import Button from '@react/react-spectrum/Button'
import { Form, FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import { success } from '@react/react-spectrum/Toast'
import Wait from '@react/react-spectrum/Wait'
import Slider from '@react/react-spectrum/Slider'

import { ProfileContext } from '../../../root/ProfileContext'
import { RootContext } from '../../../root/RootContext'
import { LogCall } from '../../../components/LogCall'

import './CustomerSatisfaction.scss'

export default function CustomerSatisfaction({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const currentProfile = profileContext.state.currentProfile
  const rootContext = useContext(RootContext)
  const [values, setValues] = useState(() => {
    return (
      content.questions &&
      content.questions.map((q) => {
        return {
          question: q,
          score: 2, //corresponds to neutral
        }
      })
    )
  })

  useEffect(() => {
    if (currentProfile) {
    }
  }, [currentProfile])

  return (
    <div className='profile-module customer-satisfaction'>
      <div className='module-content'>
        {currentProfile && (
          <div align='center'>
            {content.description && <Well>{content.description}</Well>}

            {content.showLogCallSection && <LogCall evtName='submitChurn' />}
            <Form aria-labelledby='csat-form' className='csat-form'>
              {values &&
                values.map((item, idx) => (
                  <Slider
                    key={idx}
                    step={1}
                    filled
                    min={0}
                    max={4}
                    size='L'
                    defaultValue={item.score}
                    renderLabel
                    label={item.question}
                    getAriaValueText={(score) => {
                      const values = {
                        0: 'Strongly Disagree',
                        1: 'Disagree',
                        2: 'Neutral',
                        3: 'Agree',
                        4: 'Strongly Agree',
                      }
                      return values[score]
                    }}
                    onChange={(e) => {
                      const newItems = [...values]
                      newItems[idx] = { question: item.question, score: e }
                      setValues(newItems)
                    }}
                  />
                ))}

              <div>
                <Button
                  name='submitScore'
                  variant='primary'
                  className='submit'
                  onClick={(e) => {
                    e.preventDefault()
                    const score = Math.floor(
                      (values.reduce((a, b) => {
                        return a + b.score
                      }, 0) /
                        (values.length * 4)) *
                        100
                    )

                    e.target.dispatchEvent(
                      new CustomEvent('submitScore', {
                        detail: {
                          score: score,
                          surveyDetails: JSON.stringify(values),
                        },
                      })
                    )
                    success('Customer Satisfaction Survey submitted.', {
                      onClose: () => {},
                      timeout: 4000,
                    })
                  }}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        )}
      </div>
    </div>
  )
}

CustomerSatisfaction.requiresLaunch = true
